/* Nueve Sterling shared UI: overlays with focus trap, accordions, tabs, quantity, cart API, toasts. */
(() => {
  const NS = (window.NS = window.NS || {});
  const root = document.documentElement;
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  NS.$ = $; NS.$$ = $$;
  NS.routes = window.routes || {};

  /* ---------- overlays: drawers & modals ---------- */
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type=hidden]), select, textarea, [tabindex]:not([tabindex="-1"])';
  const stack = [];
  const overlay = () => $('#ns-overlay');

  NS.open = (panel, opener) => {
    if (!panel || panel.classList.contains('is-open')) return;
    // fixed overlays must not live under a transformed/sticky ancestor
    if (panel.parentElement !== document.body) document.body.append(panel);
    panel.getBoundingClientRect();
    panel.classList.add('is-open');
    panel.removeAttribute('inert');
    panel.setAttribute('aria-hidden', 'false');
    stack.push({ panel, opener: opener || document.activeElement });
    if (panel.classList.contains('drawer')) overlay()?.classList.add('is-open');
    root.classList.add('scroll-lock');
    requestAnimationFrame(() => { (panel.querySelector('[autofocus]') || panel.querySelector(FOCUSABLE) || panel).focus({ preventScroll: true }); });
    panel.dispatchEvent(new CustomEvent('ns:open', { bubbles: true }));
  };
  NS.close = (panel) => {
    const idx = stack.findIndex((s) => s.panel === panel); if (idx < 0) return;
    const [{ opener }] = stack.splice(idx, 1);
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    panel.setAttribute('inert', '');
    if (!stack.some((s) => s.panel.classList.contains('drawer'))) overlay()?.classList.remove('is-open');
    if (!stack.length) root.classList.remove('scroll-lock');
    $$(`[aria-controls="${panel.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    opener && opener.focus && opener.focus({ preventScroll: true });
    panel.dispatchEvent(new CustomEvent('ns:close', { bubbles: true }));
  };
  document.addEventListener('keydown', (e) => {
    const top = stack[stack.length - 1]; if (!top) return;
    if (e.key === 'Escape') { e.preventDefault(); NS.close(top.panel); }
    if (e.key === 'Tab') {
      const f = $$(FOCUSABLE, top.panel).filter((el) => el.offsetParent !== null);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });
  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-open]');
    if (openBtn) { const p = document.getElementById(openBtn.dataset.open); if (p) { e.preventDefault(); openBtn.setAttribute('aria-expanded', 'true'); NS.open(p, openBtn); } return; }
    const closeBtn = e.target.closest('[data-close]');
    if (closeBtn) { const p = closeBtn.closest('.drawer, .modal'); if (p) { e.preventDefault(); NS.close(p); } return; }
    if (e.target.id === 'ns-overlay' || e.target.classList.contains('modal__backdrop')) {
      const top = stack[stack.length - 1]; top && NS.close(top.panel);
    }
  });

  /* ---------- accordions ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('.accordion__trigger'); if (!t) return;
    const panel = document.getElementById(t.getAttribute('aria-controls'));
    const open = t.getAttribute('aria-expanded') !== 'true';
    t.setAttribute('aria-expanded', open);
    panel.toggleAttribute('data-open', open);
    panel.querySelector(':scope > div')?.toggleAttribute('inert', !open);
  });

  /* ---------- tabs ---------- */
  function initTabs(scope = document) {
    $$('[role="tablist"]', scope).forEach((list) => {
      if (list.dataset.ready) return; list.dataset.ready = 1;
      const tabs = $$('[role="tab"]', list);
      const indicator = $('.tabs__indicator', list);
      const place = (tab) => {
        if (!indicator) return;
        const lr = list.getBoundingClientRect(); const tr = tab.getBoundingClientRect();
        indicator.style.setProperty('--tx', tr.left - lr.left + list.scrollLeft + 'px');
        indicator.style.setProperty('--sx', (tr.width / 100).toFixed(3));
      };
      const select = (tab, focus) => {
        tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1;
          const p = document.getElementById(t.getAttribute('aria-controls'));
          if (p) { p.hidden = !on; if (on) { p.classList.remove('is-in'); requestAnimationFrame(() => p.classList.add('is-in')); } }
        });
        place(tab); if (focus) tab.focus();
        const mirror = list.closest('section, .shopify-section')?.querySelector('[data-tabs-select]');
        if (mirror) mirror.value = tab.id;
        list.dispatchEvent(new CustomEvent('ns:tab', { detail: tab, bubbles: true }));
      };
      tabs.forEach((t, i) => {
        t.addEventListener('click', () => select(t));
        t.addEventListener('keydown', (e) => {
          const k = { ArrowRight: 1, ArrowLeft: -1, Home: -i, End: tabs.length - 1 - i }[e.key];
          if (k === undefined) return; e.preventDefault(); select(tabs[(i + k + tabs.length) % tabs.length], true);
        });
      });
      const sel = tabs.find((t) => t.getAttribute('aria-selected') === 'true') || tabs[0];
      requestAnimationFrame(() => place(sel));
      new ResizeObserver(() => place(tabs.find((t) => t.getAttribute('aria-selected') === 'true') || tabs[0])).observe(list);
    });
    // mobile dropdown mirror
    $$('[data-tabs-select]', scope).forEach((sel) => sel.addEventListener('change', () => document.getElementById(sel.value)?.click()));
  }
  NS.initTabs = initTabs;

  /* ---------- quantity inputs ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('.qty button'); if (!b) return;
    const input = b.parentElement.querySelector('input');
    const step = b.name === 'minus' ? -1 : 1;
    const min = Number(input.min || 0); const max = input.max ? Number(input.max) : Infinity;
    input.value = Math.min(max, Math.max(min, Number(input.value || 0) + step));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- toasts / live region ---------- */
  NS.announce = (msg) => { const r = $('#ns-live'); if (r) { r.textContent = ''; setTimeout(() => (r.textContent = msg), 30); } };
  NS.toast = (msg) => {
    let t = $('#ns-toast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-shown'); NS.announce(msg);
    clearTimeout(t._h); t._h = setTimeout(() => t.classList.remove('is-shown'), 3200);
  };

  /* ---------- cart API ---------- */
  const post = (url, body) => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(async (r) => { const j = await r.json(); if (!r.ok || j.status) throw j; return j; });
  const cartSections = () => $$('[data-cart-section]').map((el) => el.dataset.cartSection).filter((v, i, a) => a.indexOf(v) === i);
  NS.cart = {
    add: (items) => post((NS.routes.cart_add_url || '/cart/add') + '.js', { items, sections: cartSections().join(','), sections_url: location.pathname }).then(NS.cart.render),
    change: (line, quantity) => post((NS.routes.cart_change_url || '/cart/change') + '.js', { line, quantity, sections: cartSections().join(','), sections_url: location.pathname }).then(NS.cart.render),
    update: (body) => post((NS.routes.cart_update_url || '/cart/update') + '.js', body),
    render(res) {
      const sections = res.sections || {};
      Object.entries(sections).forEach(([id, html]) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        $$(`[data-cart-section="${id}"]`).forEach((target) => {
          const fresh = doc.querySelector(`[data-cart-section="${id}"]`);
          if (fresh) { target.innerHTML = fresh.innerHTML; document.dispatchEvent(new CustomEvent('ns:dom-updated', { detail: target })); }
        });
      });
      fetch('/cart.js').then((r) => r.json()).then((cart) => {
        $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
        document.dispatchEvent(new CustomEvent('ns:cart', { detail: cart }));
      });
      return res;
    },
  };

  /* ---------- product forms (AJAX add to cart everywhere) ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action*="/cart/add"]'); if (!form || form.dataset.native) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const err = form.querySelector('[data-form-error]');
    const data = new FormData(form);
    btn?.classList.add('is-loading'); btn?.setAttribute('aria-busy', 'true');
    if (err) err.textContent = '';
    try {
      await NS.cart.add([{ id: Number(data.get('id')), quantity: Number(data.get('quantity') || 1), properties: {} }]);
      const quick = form.closest('.modal'); if (quick) NS.close(quick);
      const drawer = $('#CartDrawer');
      if (drawer && document.body.dataset.cartType === 'drawer') NS.open(drawer); else NS.toast(window.NSStrings?.added || 'Added to cart');
    } catch (ex) {
      const msg = ex.description || ex.message || 'Error';
      if (err) err.textContent = msg; NS.announce(msg);
    } finally { btn?.classList.remove('is-loading'); btn?.removeAttribute('aria-busy'); }
  });

  /* ---------- localization selectors submit on change ---------- */
  document.addEventListener('change', (e) => { const s = e.target.closest('[data-localization-select]'); if (s) s.form.submit(); });

  /* ---------- YouTube facade ---------- */
  document.addEventListener('click', (e) => {
    const f = e.target.closest('[data-video-facade]'); if (!f) return;
    const id = f.dataset.videoFacade;
    const iframe = document.createElement('iframe');
    iframe.src = f.dataset.provider === 'vimeo' ? `https://player.vimeo.com/video/${id}?autoplay=1` : `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
    iframe.title = f.getAttribute('aria-label') || 'Video';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;
    f.replaceWith(iframe);
  });

  /* ---------- cookie banner ---------- */
  function cookie() {
    const b = $('#ns-cookie'); if (!b) return;
    let saved; try { saved = localStorage.getItem('ns-cookie'); } catch {}
    if (saved) return;
    setTimeout(() => b.classList.add('is-shown'), 1400);
    b.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-consent]'); if (!btn) return;
      const ok = btn.dataset.consent === 'accept';
      try { localStorage.setItem('ns-cookie', ok ? 'yes' : 'no'); } catch {}
      window.Shopify?.customerPrivacy?.setTrackingConsent?.({ analytics: ok, marketing: ok, preferences: ok }, () => {});
      b.classList.remove('is-shown');
    });
  }

  /* ---------- scroll to top ---------- */
  function toTop() {
    const b = $('[data-to-top]'); if (!b) return;
    const toggle = () => b.classList.toggle('is-shown', scrollY > innerHeight);
    addEventListener('scroll', toggle, { passive: true }); toggle();
    b.addEventListener('click', () => {
      NS.lenis ? NS.lenis.scrollTo(0) : scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      $('#MainContent')?.focus({ preventScroll: true });
    });
  }

  const init = () => { initTabs(); cookie(); toTop(); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('ns:dom-updated', (e) => initTabs(e.detail || document));
  document.addEventListener('shopify:section:load', (e) => initTabs(e.target));
})();
